import { BankAdditionalRoles } from '../../api/enumerations';

export const Constants = {
  title: 'Painel de Usuários',
  user: 'usuário',
  email: 'e-mail',
  role: 'função',
  access: 'acesso',
  status: 'status',
  active: 'ativo',
  newUser: 'novo usuário',
  cancel: 'cancelar',
  save: 'salvar',
  addUser: 'adicionar usuário',
  userName: 'nome completo',
  name: 'nome',
  namePlaceholder: 'digite o nome do usuário',
  emailPlaceholder: 'digite o e-mail do usuário',
  rolePlaceholder: 'selecione uma opção',
  editUser: 'editar usuário',
  buttonEdit: 'confirmar alterações',
  search: 'buscar',
  noUsersFound: 'Nenhum usuário encontrado.',
};

export const exclusiveRoles = [
  BankAdditionalRoles.BANK_ADMIN,
  BankAdditionalRoles.BANK_OPERATOR,
  BankAdditionalRoles.BANK_READ_ONLY,
];
